<i18n>
  zh-TW: {}
  en: {}
  ja: {}
  ko: {}
</i18n>
<script>
import Good from './good'
export default {
  components: {
    Good
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      intersectionObserver: null
    }
  },
  updated() {
    if (!this.intersectionObserver && this.$refs.group) {
      this.observerInit()
    }
  },
  beforeDestroy() {
    this.intersectionObserver && this.intersectionObserver.disconnect()
  },
  methods: {
    scrollToContent(index) {
      if (!this.$refs.group) {
        return
      }
      const group = this.$refs.group[index]
      if (group.offsetHeight < document.documentElement.clientHeight) {
        group
          .querySelector('.bottom-holder')
          .scrollIntoView({ behavior: 'auto', block: 'end' })
        return
      }
      group
        .querySelector('.top-holder')
        .scrollIntoView({ behavior: 'auto', block: 'start' })
    },
    // 内容滚动时，导航栏索引同步
    observerInit() {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.$emit(
              'content-scroll-change',
              +entries[0].target.dataset.index
            )
          }
        },
        { threshold: 1 }
      )
      ;[...this.$refs.group].forEach((element) => {
        this.intersectionObserver.observe(element.querySelector('.title'))
      })
    }
  },
  render() {
    if (!this.data?.length) return ''
    return (
      <div>
        {this.data.map((group, index) => {
          return (
            <div class="group" key={index} ref="group" refInFor>
              <div class="top-holder" />
              <div class="title" data-index={index}>
                {group.name}
              </div>
              <div class="desc">
                {group.children.map((item, key) => {
                  return <good class="item" key={key} detail={item} />
                })}
              </div>
              <div class="bottom-holder" />
            </div>
          )
        })}
      </div>
    )
  }
}
</script>
<style lang="scss" scoped>
.group {
  position: relative;
  .top-holder {
    position: absolute;
    top: -80px;
    z-index: 2;
  }
  .bottom-holder {
    position: absolute;
    bottom: -80px;
    z-index: 2;
  }
  .title {
    padding: 96px 0 48px;
    color: rgb(255, 255, 255);
    font-size: 32px;
    font-family: PingFang HK;
    font-weight: 500;
    text-align: center;
  }
  .desc {
    display: flex;
    flex-wrap: wrap;
  }
  .item {
    width: calc((100% - 4px) / 3);
    margin: 0 2px 2px 0;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
</style>
